<h2 mat-dialog-title class="modal-title">Welcome to OnSIP</h2>
<div mat-dialog-content class="modal-content">
  <p>Try our service by making a test call - it's our treat!</p>
  <onsip-animation filename="success_cropped"></onsip-animation>
</div>
<div mat-dialog-actions class="modal-actions">
  <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>Get Started</button>
</div>
